module.exports = __webpack_public_path__ + "static/media/hero-bg.3a913f80.png";